import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PslfAssetSchema = withDefaults({
  type: 'pslf-asset',
  traits: ['digital-asset'],
  fields: [
    {
      kind: 'hasMany',
      name: 'employees',
      type: 'employee',
      options: {
        async: false,
        inverse: 'pslfAssets',
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfProfiles',
      type: 'pslf-profile',
      options: {
        async: false,
        inverse: 'pslfAssets',
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfTemplates',
      type: 'pslf-template',
      options: {
        async: false,
        inverse: 'pslfAssets',
      },
    },
  ],
});

export default PslfAssetSchema;
